/**
 * Unique, order-preserving values for Trial Balance column filters.
 * Display rows keep reference_detail as objects, so matching uses a parallel
 * primitive array of task refs (same pattern as Information Manager).
 */

export const TASK_LINKED_FILTER_FIELD = 'referenceDetailFilterValues';

function uniqueNonEmpty(values) {
  const seen = new Set();
  const result = [];
  (values || []).forEach((value) => {
    if (value === null || value === undefined || value === '') return;
    const key = String(value);
    if (!seen.has(key)) {
      seen.add(key);
      result.push(value);
    }
  });
  return result;
}

export function buildTaskLinkedFilterValues(referenceDetail) {
  return uniqueNonEmpty((referenceDetail || []).map((entry) => entry && entry.ref ? entry.ref : ''));
}

export function normalizeTrialBalanceFilterCriteria(criteria) {
  if (!criteria || typeof criteria !== 'object') return criteria;
  const mapped = { ...criteria };
  if (Object.prototype.hasOwnProperty.call(mapped, 'reference_detail')) {
    mapped[TASK_LINKED_FILTER_FIELD] = mapped.reference_detail;
    delete mapped.reference_detail;
  }
  return mapped;
}
